import React from "react";
import TrackPlayer from "./TrackPlayer/TrackPlayer";
import CartIcon from "../../assets/images/cart-shopping.svg";

export const AudiobooksContainer2 = ({ data, activeTrackId, setActiveTrackId, onTrackEnd, isReleased }) => {
  return (
    <div className={`audiobook-container reveal ${isReleased ? '' : 'not_released'}`} key={data.id}>
      <TrackPlayer
        currentTrack={data}
        logo={CartIcon}
        activeTrackId={activeTrackId}
        setActiveTrackId={setActiveTrackId}
        onTrackEnd={onTrackEnd}
      />
    </div>
  );
};